import { EditorView } from '@codemirror/view';

/**
 * Theme that defers to host CSS variables. Hosts get their palette
 * by binding `--editor-*` (and the project's existing `--accent`,
 * `--font-display`, `--font-body`) on a wrapping element. Nothing
 * here is hard-coded so a future client can drop the package in and
 * pick up its own palette automatically.
 */
export const houseopsTheme = EditorView.theme({
  '&': {
    color: 'var(--editor-fg, currentColor)',
    background: 'transparent',
    height: '100%',
  },
  '.cm-scroller': {
    fontFamily: 'var(--editor-font-body, var(--font-body, ui-sans-serif, system-ui, sans-serif))',
    fontSize: '1rem',
    lineHeight: '1.6',
  },
  '.cm-content': {
    padding: '12px 4px',
    caretColor: 'var(--editor-cursor, var(--accent, #6F7E68))',
  },
  '.cm-cursor': { borderColor: 'var(--editor-cursor, var(--accent, #6F7E68))' },
  '.cm-activeLine': { background: 'transparent' },
  '.cm-selectionBackground, ::selection': {
    background: 'var(--editor-selection, rgba(111,126,104,0.18))',
  },
  '&.cm-focused': { outline: 'none' },

  // Live-preview decoration classes (Phase D).
  '.cm-live-heading-1': {
    fontFamily: 'var(--editor-font-display, var(--font-display, serif))',
    fontSize: '1.6rem',
    fontWeight: '600',
    lineHeight: '1.2',
  },
  '.cm-live-heading-2': {
    fontFamily: 'var(--editor-font-display, var(--font-display, serif))',
    fontSize: '1.3rem',
    fontWeight: '600',
    lineHeight: '1.25',
  },
  '.cm-live-heading-3': {
    fontFamily: 'var(--editor-font-display, var(--font-display, serif))',
    fontSize: '1.1rem',
    fontWeight: '600',
    lineHeight: '1.3',
  },
  '.cm-live-bold': { fontWeight: '600' },
  '.cm-live-italic': { fontStyle: 'italic' },
  '.cm-live-code': {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    background: 'var(--editor-code-bg, rgba(0,0,0,0.05))',
    padding: '0.05em 0.3em',
    borderRadius: '3px',
    fontSize: '0.92em',
  },
  '.cm-live-quote-line': {
    borderLeft: '3px solid var(--editor-accent, var(--accent, #6F7E68))',
    paddingLeft: '14px',
    color: 'var(--editor-muted, #57544f)',
    fontStyle: 'italic',
  },
  '.cm-live-link': {
    color: 'var(--editor-link, var(--accent, #6F7E68))',
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
  },
  '.cm-live-bullet-line': { paddingLeft: '0.4em' },
  '.cm-live-ordered-line': { paddingLeft: '0.2em' },
  '.cm-live-hr': {
    display: 'inline-block',
    width: '100%',
    height: '1px',
    background: 'var(--editor-rule, rgba(28,27,27,0.12))',
    verticalAlign: 'middle',
    margin: '0.6em 0',
  },
});
